module.exports = __webpack_public_path__ + "media/images/installing-df64df55b408d172079269594385e5a0.svg";